import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6d20730"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contain-title" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "form__title" }, "Acesse:")
], -1))
const _hoisted_2 = { class: "contain-inputs" }
const _hoisted_3 = { class: "contain-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "login-document"
}, [
  /*#__PURE__*/_createTextVNode(" CPF ou E-mail "),
  /*#__PURE__*/_createElementVNode("sup", { class: "required" }, "*")
], -1))
const _hoisted_5 = { class: "contain-input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "login-password"
}, [
  /*#__PURE__*/_createTextVNode("Senha "),
  /*#__PURE__*/_createElementVNode("sup", { class: "required" }, "*")
], -1))
const _hoisted_7 = ["type"]
const _hoisted_8 = { class: "contain-submit" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  form: "login-form",
  "data-input": "",
  type: "submit",
  class: "form__submit",
  value: "Entrar"
}, null, -1))
const _hoisted_10 = { class: "form__option" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    id: "login-form",
    ref: "root",
    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
    class: "form"
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleLogin'))),
      class: "content__button",
      type: "button"
    }, " X "),
    _hoisted_1,
    _createElementVNode("fieldset", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "data-input": "",
          id: "login-document",
          type: "text",
          form: "login-form",
          class: "form__input glass-border",
          placeholder: "CPF ou e-mail",
          autocomplete: "off",
          maxlength: "254",
          required: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userInput.loginMask) = $event)),
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unmaskCPF && _ctx.unmaskCPF(...args))),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.maskCPF && _ctx.maskCPF(...args)))
        }, null, 544), [
          [_vModelText, _ctx.userInput.loginMask]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "data-input": "password",
          id: "login-password",
          type: _ctx.isPasswordVisible ? 'text' : 'password',
          form: "login-form",
          class: "form__input glass-border",
          placeholder: "Senha",
          autocomplete: "off",
          required: "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInput.password) = $event))
        }, null, 8, _hoisted_7), [
          [_vModelDynamic, _ctx.userInput.password]
        ]),
        _createElementVNode("span", {
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
          class: _normalizeClass(["form__input__visibility", _ctx.isPasswordVisible ? '' : 'notVisible'])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_ctx.isDecolaTemplate())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('toggleRegisterModal')), ["prevent"])),
                class: "form__option__link__registration"
              }, " Crie uma conta "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('recoverPassword')), ["prevent"])),
            class: "form__option__link"
          }, " Esqueci minha senha ")
        ])
      ])
    ])
  ], 544))
}